import { HOURS_FETCH_REQUEST, HOURS_FETCH_SUCCESS, HOURS_FETCH_FAILURE } from './types';

const initialState = {
    loading: false,
    hours: {},
    error: ''
}

const hours = (state = initialState, action) => {
    switch (action.type) {
        case HOURS_FETCH_REQUEST:
            return {
                loading: true,
                hours: {},
                error: '',
            }
        case HOURS_FETCH_SUCCESS:
            return {
                loading: false,
                hours: action.payload,
                error: ''
            }
        case HOURS_FETCH_FAILURE:
            return {
                loading: false,
                hours: {},
                error: action.payload
            }
        default:
            return state
    }
}

export default hours;